import React from "react";
import { Link } from "gatsby";
import iso9001 from "../../pdfs/Novacom-ISO-9001-Certificate-2025.pdf";
import iso27001 from "../../pdfs/Novacom-ISO-27001-2022-Certificate-2025.pdf";
import { NewsletterFooterFormBrevo } from "../forms/NewsletterFooterFormBrevo";

import {
  RiFacebookCircleFill,
  RiYoutubeFill,
  RiLinkedinBoxFill,
  RiInstagramFill,
} from "react-icons/ri";

export default function Footer() {
  return (
    <footer>
      <div className="container mx-auto max-w-full bg-white">
        <div className="bg-novaPurple p-8 lg:px-14 pb-14 py-16 lg:pt-24">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-12 lg:grid-cols-16 gap-4">
              <div className="col-span-12 lg:col-span-6">
                <img
                  src="https://novacom.group/gatsby/wp-content/uploads/2025/02/novacom-logo.svg"
                  alt="Novacom"
                  layout="fixed"
                  width={150}
                  height={20.6897}
                  className="mb-8"
                />
                <p className="text-white text-2xl sm:text-3xl leading-tight font-light">
                  At Novacom, we’re not just about{"\u00A0"}ideas – we’re about{" "}
                  <span className="font-bold">making them{"\u00A0"}happen</span>
                  .
                </p>
                <p className="text-white text-lg opacity-85 pt-4">
                  <a
                    href={iso9001}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:underline"
                    aria-label="ISO 9001 certificate (opens in a new tab)"
                  >
                    ISO 9001
                  </a>
                  ,{" "}
                  <a
                    href={iso27001}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:underline"
                    aria-label="ISO 27001 certificate (opens in a new tab)"
                  >
                    ISO 27001
                  </a>{" "}
                  certified and
                  <br />{" "}
                  <a
                    href="https://en.wikipedia.org/wiki/General_Data_Protection_Regulation"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:underline"
                    aria-label="GDPR (opens in a new tab)"
                  >
                    100% GDPR compliant
                  </a>
                </p>

                <p className="text-white font-medium text-lg pb-0 lg:pb-8 pt-20 hidden lg:block lg:pt-[246px]">
                  © {new Date().getFullYear()} Novacom Group Limited
                  <br />{" "}
                  <Link
                    to="/legal-and-privacy"
                    className="hover:underline hover:underline-offset-8"
                  >
                    Legal & Privacy Policy
                  </Link>
                </p>
              </div>
              <div className="col-span-4 lg:col-span-2"></div>
              <div className="col-span-12 lg:col-span-8">
                <div className="grid grid-cols-2 gap-4 pb-8">
                  <div className="col-span-1 md:col-span-1">
                    <p className="text-white font-medium text-lg pb-6">
                      Discover more
                    </p>
                    <ul className="text-white text-xl">
                      <li className="pb-2">
                      <Link
                        to="/services"
                        className="hover:underline hover:underline-offset-8"
                      >
                        <span className="pb-2">Services</span>
                      </Link></li><li className="pb-2">
                      <Link
                        to="/work"
                        className="hover:underline hover:underline-offset-8"
                      >
                        <span className="pb-2">Our work</span>
                      </Link></li><li className="pb-2">
                      <Link
                        to="/about-us"
                        className="hover:underline hover:underline-offset-8"
                      >
                        <span className="pb-2">About Novacom</span>
                      </Link></li>
                    </ul>
                  </div>
                  <div className="col-span-1 md:col-span-1">
                    <p className="text-white font-medium text-lg pb-6">
                      Let’s chat
                    </p>
                    <ul className="text-white text-xl">
                      <li className="pb-2">
                        <Link
                          to="/contact-us"
                          className="hover:underline hover:underline-offset-8"
                        >
                          Contact us
                        </Link>
                      </li>
                      <li className="pb-2">
                        <Link
                          to="/careers"
                          className="hover:underline hover:underline-offset-8"
                        >
                          Careers
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <p className="text-white font-medium text-lg pb-4">
                  Sign up to our monthly newsletter
                </p>

                <NewsletterFooterFormBrevo />

                <div className="grid grid-cols-2 gap-4 pb-8 pt-10">
                  <div className="col-span-2 sm:col-span-1">
                    <p className="text-white font-medium text-lg pb-6">
                      Find us
                    </p>
                    <p className="text-white text-xl">The Old Granary</p>
                    <p className="text-white text-xl">Cambridge</p>
                    <p className="text-white text-xl">CB10 2ET, UK</p>
                  </div>
                  <div className="col-span-2 sm:col-span-1 pt-6 sm:pt-0">
                    <p className="text-white font-medium text-lg pb-6">
                      Follow us
                    </p>

                    <a
                      href="https://www.linkedin.com/company/novacomcorp"
                      target="_blank"
                      className="mr-2"
                      rel="noreferrer"
                      aria-label="LinkedIn (opens in a new tab)"
                    >
                      <div className="relative inline-flex items-center justify-center px-2 py-2 w-10 h-10 overflow-hidden text-black bg-white rounded-full group">
                        <span className="absolute w-0 h-0 transition-all duration-500 ease-in-out bg-novaYellow rounded-full group-hover:w-10 group-hover:h-10"></span>

                        <span className="absolute inset-0 w-full h-full -mt-1 rounded-lg"></span>
                        <span className="relative text-base font-semibold">
                          <RiLinkedinBoxFill className="text-2xl" />
                        </span>
                      </div>
                    </a>
                    <a
                      href="https://www.youtube.com/user/novacomcorp"
                      target="_blank"
                      className="mr-2"
                      rel="noreferrer"
                      aria-label="YouTube (opens in a new tab)"
                    >
                      <div className="relative inline-flex items-center justify-center px-2 py-2 w-10 h-10 overflow-hidden text-black bg-white rounded-full group">
                        <span className="absolute w-0 h-0 transition-all duration-500 ease-in-out bg-novaYellow rounded-full group-hover:w-10 group-hover:h-10"></span>

                        <span className="absolute inset-0 w-full h-full -mt-1 rounded-lg"></span>
                        <span className="relative text-base font-semibold">
                          <RiYoutubeFill className="text-2xl" />
                        </span>
                      </div>
                    </a>
                    <a
                      href="https://www.facebook.com/novacomcorp"
                      target="_blank"
                      className="mr-2"
                      rel="noreferrer"
                      aria-label="Facebook (opens in a new tab)"
                    >
                      <div className="relative inline-flex items-center justify-center px-2 py-2 w-10 h-10 overflow-hidden text-black bg-white rounded-full group">
                        <span className="absolute w-0 h-0 transition-all duration-500 ease-in-out bg-novaYellow rounded-full group-hover:w-10 group-hover:h-10"></span>

                        <span className="absolute inset-0 w-full h-full -mt-1 rounded-lg"></span>
                        <span className="relative text-base font-semibold">
                          <RiFacebookCircleFill className="text-2xl" />
                        </span>
                      </div>
                    </a>
                    <a
                      href="https://www.instagram.com/novacomcorp"
                      target="_blank"
                      className="mr-2"
                      rel="noreferrer"
                      aria-label="Instagram (opens in a new tab)"
                    >
                      <div className="relative inline-flex items-center justify-center px-2 py-2 w-10 h-10 overflow-hidden text-black bg-white rounded-full group">
                        <span className="absolute w-0 h-0 transition-all duration-500 ease-in-out bg-novaYellow rounded-full group-hover:w-10 group-hover:h-10"></span>

                        <span className="absolute inset-0 w-full h-full -mt-1 rounded-lg"></span>
                        <span className="relative text-base font-semibold">
                          <RiInstagramFill className="text-2xl" />
                        </span>
                      </div>
                    </a>
                  </div>
                </div>
                <p
                  className="text-white font-medium text-lg pb-8
                 block lg:hidden"
                >
                  © {new Date().getFullYear()} Novacom Group Limited
                  <br />{" "}
                  <Link
                    to="/legal-and-privacy"
                    className="hover:underline hover:underline-offset-8 font-medium text-lg font-sans"
                  >
                    Legal & Privacy Policy
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
